import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from '@chakra-ui/react';

import { QuestionCircleFilled } from '@/client/components/icons/ContinuIcons';

interface HelpTextPopoverProps {
  popoverContent: React.ReactNode;
}

export default function HelpTextPopover({ popoverContent }: HelpTextPopoverProps) {
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Popover
      returnFocusOnClose={false}
      isOpen={isOpen}
      onClose={onClose}
      closeOnBlur={false}
      placement="top-end"
    >
      <PopoverTrigger>
        <QuestionCircleFilled
          boxSize={4}
          color="warmNeutral.500"
          onMouseEnter={onToggle}
          onMouseLeave={onClose}
        />
      </PopoverTrigger>

      <PopoverContent padding={3} backgroundColor="baseBlack" color="white" borderRadius="8px">
        <PopoverArrow backgroundColor="baseBlack" />

        <PopoverBody padding={0}>{popoverContent}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
